import { Skeleton } from "@/components/ui/skeleton";
import { memo } from "react";
function PatientItemPlaceholder() {
  return (
    <div className="w-full flex p-3 gap-2 border shadow rounded-md">
      <Skeleton className=" rounded-full border  w-12 h-12" />
      <div className="grow flex flex-col  justify-center gap-2">
        <Skeleton className="h-5 w-30 border" />
        <Skeleton className="h-3 w-20 border" />
      </div>
      <div className="flex gap-2 justify-end items-center">
        <Skeleton className="h-8 w-8 border" />
        <Skeleton className="h-8 w-8 border" />
      </div>
    </div>
  );
}
export default memo(PatientItemPlaceholder);
